/* eslint-disable react/jsx-no-useless-fragment */
import React, { FC } from 'react';
import { Navigate } from 'react-router';
import RouteUrlPaths from '../../RouteUrlPaths';
import ManageUserAccessStore from '../../stores/ManageUserAccessStore';

interface ProtectedPaymentCardsRouteProps {
  manageUserAccessStore: ManageUserAccessStore;
}

const ProtectedPaymentCardsRoute: FC<ProtectedPaymentCardsRouteProps> = (props) => {
  const { manageUserAccessStore, children } = props;
  if (!manageUserAccessStore.showPaymentCardsPage()) {
    return <Navigate to={RouteUrlPaths.Frontpage} />;
  }
  return <>{children}</>;
};

export default ProtectedPaymentCardsRoute;
